import { makeStyles } from '@material-ui/core';
import { ThemeInstance } from 'configs/theme';

export const useStyles = makeStyles((theme: ThemeInstance) => ({
  filtersBar: {
    padding: 10,
    marginBottom: 20,
  },
  label: {
    marginRight: 20,
    fontSize: 15,
    fontWeight: 600,
    color: '#fff',
    [theme.breakpoints.down(theme.size.sm)]: {
      marginRight: 0,
      marginBottom: 10,
    },
  },
  controlWrapper: {
    [theme.breakpoints.down(theme.size.sm)]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
    [theme.breakpoints.down(theme.size.xs)]: {
      width: '100%',
    },
  },
  btn: {
    marginLeft: 13,
    background: '#F0F3F7',
    '&:hover': {
      background: '#dfe6ee',
    },
  },
  value: {
    fontSize: 15,
    fontWeight: 400,
    color: '#fff',
  },
  selectRoot: {
    width: '100%',
    justifyContent: 'space-between',
  },
  title: {
    margin: 0,
    marginRight: 15,
  },
}));
